export default "__VITE_ASSET__c5323339__"